<ul class="nav nav-tabs nav-fill mb-1" id="pills-tab" role="tablist">
    <li class="nav-item" role="presentation">
        <button class="nav-link active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" role="tab"
            aria-controls="pills-home" aria-selected="true">
            <strong>{{'USER.RESERVATIONS.reservations' | translate}}</strong>
        </button>
    </li>
    <li class="nav-item" role="presentation">
        <button class="nav-link" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" role="tab"
            aria-controls="pills-profile" aria-selected="false">
            <strong>{{'USER.RESERVATIONS.settings' | translate}}</strong>
        </button>
    </li>
</ul>
<div class="tab-content" id="pills-tabContent">
    <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
        <small class="form-text text-muted mb-1">
            {{'USER.RESERVATIONS.reservationsHelpText' | translate}}
        </small>
        <div class="list-group">
            <app-reservation-item [reservation]="reservation" [index]="i"
                *ngFor="let reservation of reservations; let i=index">
            </app-reservation-item>
        </div>
    </div>
    <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
        <div class="row">
            <div class="col">
                <div class="card g-brd-gray-light-v7 g-mb-30 g-brd-gray-light-v4">
                    <div class="row">
                        <div class="col">
                            <div class="card-body">
                                <div class="form-group row m-0">
                                    <label class="col-12 col-md-6 col-form-label pl-0">
                                        {{'USER.RESERVATIONS.blockReservationAt' | translate}}
                                    </label>
                                    <div class="col-12 col-md-6 pr-0">
                                        <div class="input-group">
                                            <input type="number" class="form-control" placeholder="Numero"
                                                [(ngModel)]="settings.blockReservationAt" #blockReservatioAtInput
                                                id="max-res-people-input">
                                            <div class="input-group-append">
                                                <button class="btn btn-primary" type="button"
                                                    id="save-max-res-people-btn"
                                                    (click)="onReservationDetailsSaveClick(1)">
                                                    {{'GENERAL.save' | translate}}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="card-body">
                                <div class="form-group row m-0">
                                    <label class="col-12 col-md-6 col-form-label pl-0">
                                        {{'USER.RESERVATIONS.expireReservationAt' | translate}}
                                    </label>
                                    <div class="col-12 col-md-6 pr-0">
                                        <div class="input-group">
                                            <input type="number" class="form-control" placeholder="Numero"
                                                id="max-time-input" [(ngModel)]="settings.expireReservationAt">
                                            <div class="input-group-append">
                                                <button class="btn btn-primary" type="button"
                                                    (click)="onReservationDetailsSaveClick(2)"
                                                    id="save-max-time-btn">{{'GENERAL.save' | translate}}</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>



<!-- <div class="row">
    <div class="col-12">
        <h4 class="color-primary" (click)="onShowSettingsArrowClick()">
            {{'USER.RESERVATIONS.settings' | translate}} <fa-icon [icon]="icons['faArrowDown']"
                class="float-right d-block d-sm-none"></fa-icon>
        </h4>
        <hr />
    </div>
</div>
<div [class]="defaultSettingsContainerClass" #hideForMobileContent>
    <div class="row mt-3">
        <div class="col">
            <div class="card g-brd-gray-light-v7 g-mb-30 g-brd-gray-light-v4">
                <div class="row">
                    <div class="col">
                        <div class="card-body">
                            <div class="form-group row m-0">
                                <label for="colFormLabelSm" class="col-12 col-md-6 col-form-label pl-0">
                                    {{'USER.RESERVATIONS.blockReservationAt' | translate}}
                                </label>
                                <div class="col-12 col-md-6 pr-0">
                                    <div class="input-group">
                                        <input type="number" class="form-control" placeholder="Numero"
                                            [(ngModel)]="settings.blockReservationAt" #blockReservatioAtInput
                                            id="max-res-people-input">
                                        <div class="input-group-append">
                                            <button class="btn btn-primary" type="button" id="save-max-res-people-btn"
                                                (click)="onReservationDetailsSaveClick(1)">
                                                {{'GENERAL.save' | translate}}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="card-body">
                            <div class="form-group row m-0">
                                <label for="colFormLabelSm" class="col-12 col-md-6 col-form-label pl-0">
                                    {{'USER.RESERVATIONS.expireReservationAt' | translate}}
                                </label>
                                <div class="col-12 col-md-6 pr-0">
                                    <div class="input-group">
                                        <input type="number" class="form-control" placeholder="Numero"
                                            id="max-time-input" [(ngModel)]="settings.expireReservationAt">
                                        <div class="input-group-append">
                                            <button class="btn btn-primary" type="button"
                                                (click)="onReservationDetailsSaveClick(2)"
                                                id="save-max-time-btn">{{'GENERAL.save' | translate}}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="row mt-3">
    <div class="col-12">
        <h4 class="color-primary">{{'USER.RESERVATIONS.reservations' | translate}}</h4>
        <small class="form-text text-muted">
            {{'USER.RESERVATIONS.reservationsHelpText' | translate}}
        </small>
        <hr />
    </div>
    <div class="col-12">
        <div class="list-group">
            <app-reservation-item [reservation]="reservation" [index]="i"
                *ngFor="let reservation of reservations; let i=index">
            </app-reservation-item>
        </div>
    </div>
</div> -->
